import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithRefreshTokenHandler } from "../authFetchBaseQuery";
import {
  IFormTypes,
  IStoreDepositsRequest,
  IStoreDepositsResponse,
  ITaxFormRequest,
  ITaxFormResponse
} from "../../types/types";
import {
  API_GET_FORM_TYPES,
  API_GET_STORE_DEPOSITS,
  API_GET_TAX_FORM
} from "../ApiConstants";

export const reportApi = createApi({
  reducerPath: "reportApi",
  baseQuery: baseQueryWithRefreshTokenHandler,
  refetchOnMountOrArgChange: true,

  endpoints: builder => ({
    getStoreDeposits: builder.query<
      IStoreDepositsResponse[],
      IStoreDepositsRequest
    >({
      query: request => ({
        url: `${API_GET_STORE_DEPOSITS}`,
        method: "POST",
        body: request
      }),

      // Keep the data for a minimal time to reduce unnecessary re-fetching
      keepUnusedDataFor: 0
    }),

    getFormTypes: builder.query<IFormTypes[], string>({
      query: countryCode => ({
        url: `${API_GET_FORM_TYPES}?countryCode=${countryCode}`,
        method: "GET"
      }),

      // Keep the data for a minimal time to reduce unnecessary re-fetching
      keepUnusedDataFor: 0
    }),

    getTaxForm: builder.query<ITaxFormResponse, ITaxFormRequest>({
      query: request => ({
        url: `${API_GET_TAX_FORM}?accountHolderId=${request.accountHolderId}&formType=${request.formType}&year=${request.year}`,
        method: "GET"
      }),

      // Keep the data for a minimal time to reduce unnecessary re-fetching
      keepUnusedDataFor: 0
    })
  })
});

export const {
  useGetStoreDepositsQuery,
  useGetFormTypesQuery,
  useLazyGetTaxFormQuery
} = reportApi;
